export const FareType = {
    Unknown: 0,
    Single: 1,
    Double: 2,
    Fixed: 3,
    Wait: 4
};

export const FareTypeMixin = {
    data() {
        return {
            fareTypes: FareType
        };
    },
    filters: {
        fareTypeToText: function(value) {
            switch (value) {
            case FareType.Unknown:
                return "Tuntematon";
            case FareType.Single:
                return "Single";
            case FareType.Double:
                return "Double";
            case FareType.Fixed:
                return "Kiinteä";
            case FareType.Wait:
                return "Odotus";
            }
        },
        fareToToolTipText: function(value) {
            let vat = !value.vat ? "" : ", Vat: " + value.vat;
            return "Sum: " + value.price + vat;
        }
    }
};
